<template>
  <page class="wrapper">
    <template v-if="!invaild">
      <live-header @handleSearch="searchList" placeholder="请输入精彩直播">
      </live-header>
      <live-banner ref="banner" :detail="detail" @mobileWatch="showCode" @enterLive="certaficate"></live-banner>
      <template slot="content">
        <div class="content-one">
          <div class="introduce">
            <div class="common-title-style">直播内容介绍</div>
            <div v-html="detail.introduction" v-if="detail.introduction" class="content-introduction"></div>
            <div  v-else class="content-introduction">暂无数据</div>
          </div>
          <hot-rank class="rank-wrap" ref="rank" :list="rankList">
                <template slot="rank-title">嘉实热播榜</template>
          </hot-rank>
        </div>
        <look-more title="精彩直播推荐" :liveDetail="true" :data="list" v-if="list.length" @lookMore="lookMore(detail)"/>
        <template v-if="list.length"><list class="list-item" :class="{'forth':i==3}"  @look="handLook" v-for="(v,i) in list" :key="v.id" :item="v"></list></template>
        <certificate-dialog ref="certificateDialog" @confirm="confirm"/>
        <authoriza-dialog ref="authorizaDialog" @confirmCode="confirmCode"/>
        <code-dialog ref="codeDialog"/>
        <investor-dialog ref="investorDialog" :detail="detail" @investorConfrim="hasBanCode"/>
        <roadShowStatusDialogVue ref="roadShowStatusDialog" :detail="detail" @confirm="jumpLive"></roadShowStatusDialogVue>
    </template>
    </template>
    <template v-else>
      <div class="invaild">
        <div class="img-wrap">
          <img src="@/assets/image/useless.png" class="img" alt="">
          <p class="invaild-desc">内容已失效</p>
        </div>
      </div>
    </template>
  </page>
</template>
<script>
import Page from '@/views/layout/index'
import List from '@/views/components/list'
import HotRank from '@/components/rank'
import { getLcWeb } from '@/api/lc_web'
import { getToken, jiashiUserInfo, jiashiPreregister } from '@/api/jiashi_web'
import LookMore from '@/views/components/lookMore'
import LiveHeader from '@/components/header'
import certificateDialog from './com/certificateDialog.vue'
import authorizaDialog from './com/authorizaDialog.vue'
import investorDialog from './com/investorIdentificate.vue'
import codeDialog from './com/codeDialog.vue'
import LiveBanner from './com/live_banner.vue'
import roadShowStatusDialogVue from './com/roadShowStatusDialog.vue'
export default {
  inject: ['reload'], // 注入函数
  components: {
    Page,
    List,
    HotRank,
    LookMore,
    LiveHeader,
    LiveBanner,
    certificateDialog,
    authorizaDialog,
    codeDialog,
    investorDialog,
    roadShowStatusDialogVue
  },
  data () {
    return {
      invaild: false,
      list: [],
      id: '',
      detail: {},
      timer: null,
      rankList: [],
      valueData: {},
      isInvestor: false,
      avoidLoading: false
    }
  },
  mounted () {
    this.id = this.$route.query.id ? this.$route.query.id : ''
    this.getDetail()
  },
  watch: {
    $route: function (val) {
      this.refresh()
    }
  },
  methods: {
    refresh () {
      this.reload()
    },
    /* 获取详情 */
    async getDetail () {
      this.invaild = false
      const obj = {
        name: 'lc.market.content.get',
        data: {
          id: this.id
        }
      }
      const res = await getLcWeb(obj)
      if (res.code === 0) {
        if (res.value) {
          const temp = res.value && Object.keys(res.value).length ? res.value : {}
          this.$refs.banner.detailData = temp
          this.detail = temp
          this.getList()
          this.getRank()
        } else {
          // 链接失效的情况
          this.invaild = true
        }
      } else {
        this.$refs.banner.detailData = {}
        this.detail = {}
        this.$showError(res.msg)
      }
    },
    /* 获取热播榜 */
    getRank () {
      const obj = {
        name: 'lc.hot.bord',
        data: {
        }
      }
      getLcWeb(obj).then(res => {
        if (res.code === 0) {
          this.rankList = res.rows ? res.rows : []
        } else {
          this.$showError(res.msg)
        }
      })
    },
    /* 获取精彩直播 */
    async getList () {
      const obj = {
        name: 'lc.category.recommend',
        data: {
          liveId: this.detail.id,
          wbsCategoryId: this.detail.wbsCategoryId
        }
      }
      const res = await getLcWeb(obj)
      if (res.code === 0) {
        this.list = res.rows ? res.rows : []
      } else {
        this.$showError(res.msg)
      }
    },
    searchList (val) {
      this.$router.push({
        name: 'live',
        params: {
          keyword: val || ''
        }
      })
    },
    /* 跳转至更多列表页 */
    lookMore (val) {
      this.$router.push({
        name: 'live',
        query: {
          id: val.wbsCategoryId
        }
      })
    },
    /* 查看详情 */
    handLook (val) {
      this.id = val.id
      this.getDetail()
    },
    /* 二维码展示 */
    showCode (val) {
      this.$refs.codeDialog.dialogVisible = true
      this.$refs.codeDialog.init({ id: this.detail.id })
    },
    /* 进去直播前的各种认证 */
    async certaficate (val) {
      // 直播链接不存在
      if (!this.detail || !this.detail.liveUrl) {
        return
      }
      // 未登录
      if (!this.$store.state.user.token && +val.investorVisible === 1) {
        this.$refs.certificateDialog.dialogVisible = true
        return
      }
      // 直播登录可见 investorVisible  0 不可见，1可见
      if (!val.investorVisible) {
        this.hasBanCode(val)
      } else if (this.$store.state.user.token && +val.investorVisible === 1) {
        this.customerFrim(val)
      }
      // if (!val.investorVisible || (this.$store.state.user.token && +val.investorVisible === 1)) { // 登录不可见且未登录过
      //   // 是否开启授权码
      //   if (+this.detail.ifBanCode === 2) {
      //     const opt = {
      //       name: 'lc.app.live.ifNeedAuthCode',
      //       data: {
      //         userNo: this.$store.state.user.uid,
      //         liveId: this.detail.id
      //       }
      //     }
      //     const auth = await getLcWeb(opt)
      //     if (auth.value === true) {
      //       this.$refs.authorizaDialog.dialogVisible = true
      //       this.valueData = val
      //     } else {
      //       this.customerFrim(this.valueData)
      //     }
      //   } else {
      //     this.customerFrim(val)
      //   }
      // }
    },
    async customerFrim (val) {
      if (+val.investorFirm === 1) {
        // 已登录
        const obj = {
          name: 'lc.app.live.customerFirmVerify',
          data: {
            customerNo: this.$store.state.user.uid,
            liveId: this.detail.id
          }
        }
        // 是否需要投资人认证
        const res = await getLcWeb(obj)
        if (res.code === 0) {
          if (!res.value.liveId) {
            this.isInvestor = false
          } else {
            this.isInvestor = true
          }
        } else {
          this.$store.commit('CLEAR_USERINFO')
          // this.$refs.certificateDialog.dialogVisible = true
          // this.$showError(res.msg)
          return
        }
        // investorFirm 0 不需要 ，1需要
        if (!this.isInvestor) {
          this.$refs.investorDialog.dialogVisible = val.investorFirm === 1
          if (!val.investorFirm) {
            // this.jumpLive()
            // 路演规则判断
            this.hasRoadShow(val)
          }
        } else {
          this.hasBanCode(val)
        }
      } else {
        // this.jumpLive()
        // 路演规则判断
        this.hasRoadShow(val)
      }
    },
    /* 登录获取用户信息 */
    checkUserInfoAgain (obj) {
      return new Promise((resolve, reject) => {
        const that = this
        jiashiUserInfo(obj.data).then(res => {
          that.avoidLoading = false
          if (res.value) {
            let temp = res.value.substring(6)
            temp = temp.replace(/\n/ig, '')
            res.value = JSON.parse(temp)
          } else {
            let temp = res.substring(6)
            temp = temp.replace(/\n/ig, '')
            res = JSON.parse(temp)
          }
          resolve(res)
        })
      })
    },
    async confirmCode (auth) {
      const obj = {
        name: 'lc.app.live.authCodeCreate',
        data: {
          authCode: auth,
          userNo: this.$store.state.user.uid,
          liveId: this.detail.id
        }
      }
      const res = await getLcWeb(obj)
      if (res.code === 0) {
        this.$refs.authorizaDialog.dialogVisible = false
        // this.customerFrim(this.valueData)
        this.jumpLive()
      } else {
        this.$showError(res.msg)
      }
    },
    async confirm (mobile, code) {
      let outId = null
      console.log('outid', this.$route.query.outId)
      if (this.$route.query.outId) {
        outId = this.$route.query.outId
        console.log('outIdkkk:', outId)
      }
      if (!code) {
        this.$showError('验证码不能为空')
        return
      }
      if (this.avoidLoading) {
        return
      }
      this.avoidLoading = true
      const obj = {
        data: {
          mobile: mobile,
          verifyCode: code,
          mgrAccount: outId
        }
      }
      // 获取用户信息
      let res = await this.checkUserInfoAgain(obj)
      let resData = res.value || res
      if (resData && resData.status && resData.status.message && resData.status.message.toLowerCase() !== 'success') {
        this.$showError(resData.status.message)
        this.$refs.certificateDialog.initData(true)
        return
      }
      // 注册
      if (resData.data.needRegister) {
        this.avoidLoading = true
        const obj1 = {
          data: {
            mobile: mobile,
            mgrAccount: outId,
            sessionKey: res.sessionkey
          }
        }
        const res2 = await jiashiPreregister(obj1.data)
        let res2Data = res2.value || res2
        this.avoidLoading = false
        if (res2Data) {
          let temp = res2.value.substring(5)
          temp = temp.replace(/\n/ig, '')
          res2.value = JSON.parse(temp)
          res2Data = res2.value || res2
        }
        // 注册成功后重新登录
        if (res2Data && res2Data.data && res2Data.data.message === '注册成功') {
          res = await this.checkUserInfoAgain(obj)
          resData = res.value || res
        } else {
          this.$refs.certificateDialog.initData()
          this.$refs.certificateDialog.dialogVisible = false
          this.$showError(res2Data.status.message)
          return
        }
      }
      this.avoidLoading = true
      const obj3 = {
        name: 'passport.exchangeToken.investor',
        data: {
          customerId: resData.data.user.custNo,
          token: resData.data.token
        }
      }
      const sepcialVal = await getToken(obj3)
      this.avoidLoading = false
      if (sepcialVal.code === 0) {
        this.$store.commit('SET_TOKEN', sepcialVal.value)
        this.$store.commit('SET_USERINFO', resData.data.user)
        this.$refs.certificateDialog.dialogVisible = false
        // 调用上直播的登录--获取cookieId
        this.valueData = this.detail
        await this.investorConfrim()
        // 是否开启授权码
        if (+this.detail.ifBanCode === 2) {
          const opt = {
            name: 'lc.app.live.ifNeedAuthCode',
            data: {
              userNo: this.$store.state.user.uid,
              liveId: this.detail.id
            }
          }
          const auth = await getLcWeb(opt)
          if (auth.value === true) {
            this.$refs.authorizaDialog.dialogVisible = true
          } else {
            this.customerFrim(this.valueData)
          }
        } else {
          this.customerFrim(this.valueData)
        }
      } else {
        this.$showError(sepcialVal.msg)
      }
    },
    /* 跳转至上直播 */
    async jumpLive (val) {
      const returnTo = this.$route.query.returnTo
      if (val && !val.investorVisible) { // 登录不可见
        const res = await getLcWeb({ name: 'lc.visitor.cookie', data: {} })
        if (res.code === 0) {
          let url = ''
          if (returnTo) {
            url = `${this.detail.liveUrl}?parSid=${res.value}&returnTo=${returnTo}`
          } else {
            url = `${this.detail.liveUrl}?parSid=${res.value}`
          }
          location.href = url
        } else {
          this.$showError(res.msg)
        }
        return
      }
      this.$refs.investorDialog.dialogVisible = false
      let cookie = this.$store.state.user.parSid
      if (!cookie) {
        await this.investorConfrim()
        cookie = this.$store.state.user.parSid
      }
      if (this.detail && this.detail.liveUrl) {
        let url = ''
        if (returnTo) {
          url = `${this.detail.liveUrl}?parSid=${cookie}&returnTo=${returnTo}`
        } else {
          url = `${this.detail.liveUrl}?parSid=${cookie}`
        }
        location.href = url
      }
    },
    /* 上直播登录 */
    investorConfrim () {
      const uid = this.$store.state.user.uid
      const nickname = this.$store.state.user.nickname ? this.$store.state.user.nickname : ''
      const obj = {
        name: 'lc.shangzhibo.login',
        data: {
          uid,
          nickname
        }
      }
      return new Promise((resolve, reject) => {
        getLcWeb(obj).then(res => {
          // 获取cookieId
          if (res.code === 0) {
            this.$store.commit('SET_COOKIEID', res.value.cookie)
            resolve(res)
          } else {
            this.$showError(res.msg)
            reject(new Error(res.msg))
          }
        })
      })
    },
    // 授权码判断
    async hasBanCode (val = this.detail) {
      if (+this.detail.ifBanCode === 2) {
        const opt = {
          name: 'lc.app.live.ifNeedAuthCode',
          data: {
            userNo: this.$store.state.user.uid,
            liveId: this.detail.id
          }
        }
        const auth = await getLcWeb(opt)
        if (auth.value === true) {
          this.$refs.authorizaDialog.dialogVisible = true
          this.valueData = val
        } else {
          this.jumpLive()
        }
      } else {
        this.jumpLive()
      }
    },
    // 路演规则判断
    async hasRoadShow (val) {
      if (+this.detail.roadShowStatus === 2) {
        const opt = {
          name: 'lc.app.live.canView',
          data: {
            userNo: this.$store.state.user.uid,
            liveId: this.detail.id
          }
        }
        const res = await getLcWeb(opt)
        if (res.code === 0) {
          if (res.value === true) {
            this.jumpLive()
          } else {
            // 路演弹框
            this.$refs.roadShowStatusDialog.show(this.detail)
          }
        } else {
          this.$message.error(res.msg)
        }
      } else {
        this.hasBanCode(val)
      }
    }
  }

}
</script>
<style lang="scss" scoped>
.wrapper ::v-deep.common-content{
  width:1200px;
  margin:0 auto;
  box-sizing:border-box;
}
.content-one{
  display:flex;
}
.introduce{
  flex:1;
  // flex-basis: calc(100% - 306px);
  // width: calc(100% - 306px);
}
.content-introduction{
   padding:48px;
   background-color:#fff;
   border-radius:6px;
}
.content-introduction ::v-deep img{
  max-width:100%;
}
.list-item{
  width:calc((100% - 72px) / 4)
}
.forth{
  margin-right:0;
  padding-right:0;
}
.rank-wrap{
  width:282px;
  margin-left:24px;
  flex-basis:282px;
}
@media screen and (max-width: 1200px){
  .wrapper ::v-deep.common-content{
    width:100%
  }
}
.invaild{
  background-color:#fff;
  height:100vh;
  width:100%;
  text-align:center;
  display:flex;
  align-items:center;
  justify-content: center;

}
.invaild-desc{
  color:#ccc;
}
</style>
